var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6191 9.53022L13.3876 12.7617L16.6191 15.9932L15.2315 17.3808L12 14.1493L8.7685 17.3808L7.38091 15.9932L10.6124 12.7617L7.38091 9.53022L8.7685 8.14263L12 11.3741L15.2315 8.14263L16.6191 9.53022ZM23.7759 12.7617C23.7759 19.2551 18.4934 24.5376 12 24.5376C5.50658 24.5376 0.224121 19.2551 0.224121 12.7617C0.224121 6.2683 5.50658 0.98584 12 0.98584C18.4934 0.98584 23.7759 6.2683 23.7759 12.7617ZM21.8132 12.7617C21.8132 7.3507 17.411 2.94849 12 2.94849C6.58898 2.94849 2.18677 7.3507 2.18677 12.7617C2.18677 18.1727 6.58898 22.575 12 22.575C17.411 22.575 21.8132 18.1727 21.8132 12.7617Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.523e1758f89d1854ba26468c38a499ef.svg";
export { ForwardRef as ReactComponent };